<template>
    <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
      <v-row class="pa-2 customer" :style="{ marginBottom: role < 6 ? '10px' : '0px' }">
        <v-col cols="9" class="py-0 d-flex align-center ga-5">
          <h2 class="clientname">WareHouse</h2>
        </v-col>
   
      </v-row>
      <div class="pa-2 table-container" style="height: 100%; width: 100%; overflow-x: auto;">
          <CommonTable @dialogs="edit" :title="'WareHouse'" @add="addWarehouse" :role="role" :headers="headers" :dataList="wareHouseDetails" />
      </div>
    </v-card>
    <v-dialog v-model="wareHouseDialog" width="600">
      <AddWarehouse @update-location="updateLocation" :viewType="viewType"  :index="index" :wareHouseForm="wareHouseForm" :designation="'Warehouse'"  @save="addCustomer"   @close="close"/>
    </v-dialog>
  </template>
  
  <script>

import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import CommonTable from '@/menus/CommonTable.vue'
import moment from "moment";
import AddWarehouse from './AddWarehouse.vue';


  export default {
    components: {
      CommonTable,
      AddWarehouse,
    },
    data() {
      return {
        headers:[
          {title:"Name",value:'warehouse_name',minWidth:'200px'},
          {title:"Code",value:'warehouse_code',minWidth:'150px'},
          {title:"Address",value:'address',minWidth:'300px'},
          {title:"Mobile Number",value:'mobile',minWidth:'200px'},
          {title:"EDI Transcations",value:'edi',minWidth:'400px'},
          {title:"FedEx",value:'fedex',minWidth:'100px'},
          { title: "Actions", value: 'actions', minWidth: '150px',}, 
        ],
        isSyncing: false,
        viewType:null,
        index:null,
        wareHouseDialog:false,
        wareHouseForm:[],
        customer:[],
        wareHouseDetails:[],
        user_id:null,
        user_name:null,
        role:null,
        excelTemplate:['customer','name','factor','edi','ucc_labels','asn','substitution','off_pack','customer_type','direct_customer','c855','c940997','courses_of_action']
      }
    },
    created() {
        this.getOrganisation();
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        this.user_name = user.username
        this.role = user.roles.role_type
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        startSync() {
          this.isSyncing = true;
          setTimeout(() => {
            this.isSyncing = false;
          }, 4000);
        },
        addWarehouse(value,viewType){
            console.log(value,"addWarehouse")
            this.viewType = viewType
            this.wareHouseDialog = true
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            this.wareHouseDetails = this.organisationData && this.organisationData.wareHouse ? this.organisationData.wareHouse : this.wareHouseDetails
        },

        close() {
            this.wareHouseDialog = false
        },
        async save() {
            this.organisationData.wareHouse = this.wareHouseDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id:this.$route.query.id
            }
            await clientDetailsService.update($data)
        },
        addCustomer($data){
            this.wareHouseDetails.push($data)
            let count = 0
            if(this.organisationData && this.organisationData.wareHouse && Array.isArray(this.organisationData.wareHouse)){
              count = this.organisationData.wareHouse.length
            }
            for(let i of this.wareHouseDetails){
              const now = moment().format('YYYY-MM-DD HH:mm:ss')
                i.id = ++count
                i.created = now
                i.modified = null
                i.created_by = this.user_id  
                i.modified_by = null
                i.modified_name = null
                i.active = 1
                i.deleted = 0
                i.deleted_by = null
            }
            this.save()
        },

        async edit($edit,bool,viewType,index){
          this.wareHouseDialog=true
          this.wareHouseForm = $edit
          this.viewType = viewType
          this.index = index
          console.log("$edit !!",$edit,bool,viewType,index)

        },

        updateLocation(data,index,type){
          console.log(data,"updatelocation !!")
            if(type == 'edit'){
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id
                data.modified_name = this.user_name
                this.wareHouseDetails[index] = data
                this.saveAllData()
            }

        },
        async saveAllData() {
            this.organisationData.wareHouse = this.wareHouseDetails
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
            // window.location.reload()
        },
    },
  };
  </script>
  
  <style scoped>
  .customer{
    display: flex;
    align-items: center;
  }
  .upload-btn {
  /* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
  color: white;
  font-weight: 600;
  text-transform: none; /* keep 'Upload' normal instead of uppercase */
  border-radius: 12px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}
  .clientname {
    font-size: 20px;
    font-weight: 600;
  }
  
  .table-container {
    width: 100%;
     /* background: #ebf1f35a; */
    background: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    /* // border: 1px solid #d2d2d2; */

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 10px;

        thead {
        border: 1px solid #cbf0fd;
        background-color: #e3f2fd;

        th {
            font-size: 1rem;
            font-weight: 500;
            padding: 12px;
            text-align: left;
            color: #000;
        }
        }

        tbody {
        tr {
            cursor: pointer;
            font-size: 0.9rem;
            font-weight: 500;
            position: relative;
            overflow: hidden;
            border: 1px solid #cbf0fd;
            border-radius: 8px;

            &:nth-child(odd) {
            background-color: #ebf1f3;
            }

            &:nth-child(even) {
            background-color: #d9dbdb;
            }

            td {
            padding: 10px;
            text-align: left;
            color: #333;
            }

            &:hover {
            background-color: #f5f5f5;
            }
        }
        }
    }
    }
    .edit-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    }

    .noWrap{
    text-wrap:nowrap;
    }
    .no-data-container{
    display:flex;
    justify-content:center;
    align-items:center;
    width: 100%;
    height:400px;
    font-size:20px; 
    font-weight:500;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
    .rotating {
      animation: spin 1s linear infinite;
    }
  </style>